"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MimeTypes = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
exports.MimeTypes = {
    excel: 'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    csv: '.csv, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values',
};
